import { IslandType } from '../../../islands/enums';
import { ActionRuleParams } from '../../types';
import { syncPromotionalSkuCount } from '../../helpers';

import type { Island } from '../../../islands/island.class';

const GRANITE_DEPTH_THRESHOLD = 40;
const SKU = 'CUSTOM_COUNTERDEPTH_INCREASE_GRANITE';

export const counterDepthIncreaseGranite = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { kitchen } = refMap;
	if (!kitchen) return;

	const islands = refMap.islands ?? kitchen.design?.islands ?? null;
	if (!islands) return;

	let qualifyingCount = 0;

	for (const child of islands.children) {
		const island = child as Island;

		// Exclude corner islands
		if (island.type === IslandType.Corner) continue;

		const countertop = island.getCountertop();
		if (!countertop) continue;

		const { material } = countertop;
		if (!material?.isGranite) continue;

		// overallSize includes overhangs
		const { overallSize } = island;
		if (overallSize.depth > GRANITE_DEPTH_THRESHOLD) {
			qualifyingCount++;
		}
	}

	syncPromotionalSkuCount({ kitchen, sku: SKU, qualifyingCount });
};
